import React from 'react';
import styled from 'styled-components';
import { Image } from '@spotify-internal/encore-web/core';

type ImageResolutionsType = {
  '1x': string;
  '2x'?: string;
};

export type BaseImageType = {
  sources: {
    small: ImageResolutionsType;
    medium?: ImageResolutionsType;
    large?: ImageResolutionsType;
  };
  label?: string;
};

export type ImagePropTypes = BaseImageType & {
  className?: string;
  children?: React.ReactNode;
};

const StyledImage = styled(Image)`
  width: 142px;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  flex-shrink: 1;
`;

const PictureImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 0 10px;
`;

function BenefitImage(props: ImagePropTypes) {
  return (
    <PictureImage>
      <StyledImage
        src={encodeURI(props.sources.small['1x'])}
        alt={props.label ?? ''}
      />
    </PictureImage>
  );
}

export default BenefitImage;
